
<div class="c-store-vacation-info">
  <div class="c-store-vacation-info__icon is-active">
    <img
      class="c-store-vacation-info__img"
      :src="require('@@/assets/images/web/pages/products/new/vacation.svg')"
      loading="lazy"
    >
  </div>

  <!-- eslint-disable vue/no-v-html -->
  <p
    v-if="message"
    class="o-text -md-long-primer -xs-brevier -xs-normal c-store-vacation-info__text"
    v-html="message"
  />
  <!-- eslint-enable -->

  <p
    v-else
    class="o-text -md-long-primer -xs-brevier -xs-normal c-store-vacation-info__text"
  >
    loja de folga. para voltar a vender e publicar novos anúncios você precisa ativá-la antes.
  </p>

  <a
    v-if="shouldShowButton"
    href="/perfil/alterar"
    class="o-button -xs-secondary -xs-small -xs-fill -xs-flat c-store-vacation-info__cta"
  >
    ativar loja
  </a>
</div>
